<template>
  <div class="wrap">
    <div class="index-wrap">
      <a href="javascript:;" @click="statistics()" class="btn"></a>
    </div>
  </div>
</template>
    
  <script>
  export default {
    components: {},
    name: "cpp5",
    data() {
      return {
        // adSwiper: null,
      };
    },
    created() {
      fbq('init', '400227422985016');
      fbq('track', 'PageView');
    },
    mounted() {
      // --
    },
    //methods中定义事件
    methods: {
      // 打点统计
      statistics() {
        fbq('track','Lead');
        // 新开链接跳转
        window.open(
          "https://apps.apple.com/kr/app/%EB%B8%94%EB%9F%AC%EB%93%9C-%EC%9C%84%EC%B9%98/id6475762323?ppid=02c06697-198a-454a-8af2-b8715a9748e0"
        );
      },
    },
  };
</script>
      
  <style lang="less" scoped>
  .index-wrap {
    width: 100%;
    height: 1620rem;
    padding-top: 1460rem;
    background-color: #000;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-image: url(../../assets/images/cpp/cpp_bg1.jpg);
  }
  .btn {
    display: block;
    width: 473rem;
    height: 111rem;
    margin-left: 134rem;
    background-image: url(../../assets/images/cpp/btn_main.jpg);
    background-size: 100% 100%;
    animation: breath 3s infinite;
  }
  // 呼吸效果
  @keyframes breath {
    0% {
      transform: scale(0.95);
    }

    50% {
      transform: scale(1.02);
    }

    100% {
      transform: scale(0.95);
    }
  }

  @media screen and (min-width: 750px) {
    .index-wrap {
      max-width: 750px;
      margin: 0 auto;
    }
  }
</style>
        